import React, { useState } from "react";
import { FaPlug, FaLightbulb, FaTable, FaCog } from "react-icons/fa";
import ArchiveTableModal from "../../components/Archive/ArchiveTableModal";
import styles from "./Monitor.module.css";

const isActiveValue = (value) => {
  return (
    value === true ||
    value === 1 ||
    value === "1" ||
    value === "true" ||
    value === "TRUE" ||
    value === "on" ||
    value === "ON"
  );
};

const getCustomName = (customNames, index) => {
  if (!customNames) return "";

  const name = customNames[index] ?? customNames[String(index)];

  if (name === undefined || name === null || String(name).trim() === "") {
    return "";
  }

  return String(name).trim();
};

const DigitalInputMonitorCard = ({
  type,
  index,
  label,
  icon,
  data,
  customNames = {},
  onOpenSettings,
  serial,
  token,
}) => {
  const [isArchiveOpen, setIsArchiveOpen] = useState(false);

  if (!data) return null;

  const { status, triggered } = data;

  const isOn = isActiveValue(status);
  const isTriggered = isActiveValue(triggered);

  const customName = getCustomName(customNames, index);
  const displayName = customName || label;
  const displayTitle = customName ? `${customName} - ${label}` : label;
  const sensorKey = `${type}${index}`;
  const isOfflinePreview = Boolean(
    data?.isOfflinePreview || data?.isLastStatePreview,
  );
  const lastSeenLabel = data?.lastSeenLabel || "";

  return (
    <div
      className={`
        ${styles.sensorCard}
        ${styles.monitorOnlyCard}
        ${isOfflinePreview ? styles.offlinePreviewCard : ""}
      `}
    >
      <div className={`${styles.cardHeader} ${styles.sensorMonitorHeader}`}>
        <div className={styles.sensorMonitorHeaderMain}>
          <div className={styles.sensorMonitorTitleBlock}>
            <div className={styles.sensorMonitorTitleTop}>
              <span className={styles.sensorMonitorMainIcon}>{icon}</span>

              <span
                className={`
                  ${styles.sensorMonitorCustomName}
                  ${!customName ? styles.cardDisplayNameDefault : ""}
                `}
                title={displayTitle}
              >
                {displayName}
              </span>
            </div>

            <div className={styles.sensorMonitorInlineActions}>
              {isOfflinePreview && lastSeenLabel && (
                <div
                  className={styles.offlineHeaderMeta}
                  title={`آخرین تغییر: ${lastSeenLabel}`}
                >
                  <span className={styles.offlineHeaderMetaTitle}>
                    آخرین تغییر
                  </span>
                  <span className={styles.offlineHeaderMetaValue}>
                    {lastSeenLabel}
                  </span>
                </div>
              )}

              {typeof onOpenSettings === "function" && (
                <button
                  type="button"
                  className={styles.monitorActionBtn}
                  onClick={(e) => {
                    e.stopPropagation();
                    onOpenSettings();
                  }}
                  title="تنظیمات این ورودی"
                  aria-label={`تنظیمات ${displayTitle}`}
                >
                  <FaCog />
                </button>
              )}

              <button
                type="button"
                className={styles.monitorActionBtn}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsArchiveOpen(true);
                }}
                title="مشاهده آرشیو جدولی"
                aria-label="مشاهده آرشیو جدولی"
              >
                <FaTable />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.centerStatus}>
        <div
          style={{
            position: "relative",
            width: "50px",
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FaPlug
            className={`
                            ${styles.powerIcon}
                            ${isOn ? styles.inputActive : styles.inputInactiveBase}
                        `}
            style={{
              transform: "rotate(180deg)",
            }}
            title={isOn ? "ورودی روشن" : "ورودی خاموش"}
          />

          {!isOn && <div className={styles.diagonalLine}></div>}
        </div>

        <div className={styles.statusText}>{isOn ? "روشن" : "خاموش"}</div>
      </div>
      <FaLightbulb
        className={`
        ${styles.cardTrigCorner}
        ${isTriggered ? styles.cardTrigCornerOn : styles.cardTrigCornerOff}
    `}
        title={isTriggered ? "Trig فعال" : "Trig غیرفعال"}
      />

      <ArchiveTableModal
        isOpen={isArchiveOpen}
        onClose={() => setIsArchiveOpen(false)}
        serial={serial}
        sensorKey={sensorKey}
        title={displayTitle}
        token={token}
      />
    </div>
  );
};

export default DigitalInputMonitorCard;
